import moment from "moment";

export const isValidEmail = (email) => {
    const emailRegEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegEx.test(email);
};

export const getLowestPrice = (tickets) => {
    if (tickets.length > 0) {
        return Math.min(...tickets.map(ticket => ticket.price));
    }
    return null;
};

export const getEventStatus = (eventDateTime) => {
    const now = moment();
    const eventTime = moment(eventDateTime, "YYYY-MM-DD,HH:mm");

    if (eventTime.isSame(now, 'day')) {
        return eventTime.isBefore(now) ? "Live Now" : `Today, ${eventTime.format("HH:mm")}`;
    } else if (eventTime.isSame(now.add(1, 'days'), 'day')) {
        return `Tomorrow, ${eventTime.format("HH:mm")}`;
    } else if (eventTime.isBefore(now)) {
        return "Event Ended";
    } else {
        return eventTime.format("Do MMM YYYY");
    }
}

export const getFormattedDateRange = (startDate, endDate) => {
    return `fromDate=${startDate}&toDate=${endDate}`;
};